"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleSummaryValueComponent = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const CircleSummaryValueComponent = (props) => (react_1.default.createElement("div", { className: (0, clsx_1.default)('circle-value-component', props.onClick && 'circle-clickable'), onClick: props.onClick },
    react_1.default.createElement("div", { className: 'value' }, props.value),
    react_1.default.createElement("div", { className: 'label' }, props.label)));
exports.CircleSummaryValueComponent = CircleSummaryValueComponent;
